module.exports = __webpack_public_path__ + "assets/img/202108-3.e52c3f0e.png";